export default __webpack_public_path__ + "static/media/trans bottom.161e2b84.png";